// Bilingual copy dictionary for ORDO by Isa (PT-PT & EN)
export const copy = {
  pt: {
    nav: {
      inicio: "Início",
      sobre: "Sobre",
      servicos: "Serviços",
      portfolio: "Portfolio",
      testemunhos: "Testemunhos",
      contacto: "Contacto",
      cta: "Agendar",
    },
    hero: {
      overline: "Personal Organizer · Algarve",
      line1: "Espaços",
      line2: "que respiram,",
      line3: "vidas em",
      line4: "harmonia.",
      sub: "A sua casa deve ser o seu refúgio. Se hoje lhe traz stress em vez de paz, está no sítio certo.",
      cta: "Agendar",
      ctaAlt: "Ver serviços",
    },
    marquee: [
      "Declutter",
      "Organize",
      "Breathe",
      "Simplify",
      "Ordem",
      "Leveza",
      "Calma",
      "Design",
    ],
    sobre: {
      overline: "Sobre",
      title: "Sou a Isa —",
      titleItalic: "e a ordem é a minha linguagem de amor.",
      p1: "A ORDO nasceu do desejo de devolver às pessoas o silêncio da casa que amam. Sou personal organizer certificada, com formação em design de interiores e mais de sete anos a transformar closets, cozinhas e escritórios pelo país.",
      p2: "O meu método é intuitivo, discreto e profundamente pessoal. Trabalho com cada família à medida da sua rotina — não impondo sistemas, mas revelando os que já existiam, escondidos debaixo do excesso.",
      stat1: { n: "120+", l: "Espaços transformados" },
      stat2: { n: "7 anos", l: "De experiência" },
      stat3: { n: "98%", l: "Clientes recorrentes" },
    },
    servicos: {
      overline: "Serviços",
      title: "Três formas",
      titleItalic: "de começar de novo.",
      items: [
        {
          num: "01",
          title: "Organização de Espaços",
          desc: "Desenho e implementação de sistemas de organização para cada divisão da casa — do closet à despensa, do escritório ao quarto das crianças.",
          bullets: ["Análise no local", "Categorização & purga", "Sistema à medida", "Etiquetagem e acabamentos"],
        },
        {
          num: "02",
          title: "Decluttering",
          desc: "Processo guiado de desapego consciente. Reencontrar o essencial, libertar espaço físico e mental, e criar uma casa que reflete quem é hoje.",
          bullets: ["Método por categorias", "Doação consciente", "Suporte emocional", "Follow-up 30 dias"],
        },
        {
          num: "03",
          title: "Consultoria",
          desc: "Sessões presenciais para quem quer reorganizar a vida e a casa.",
          bullets: ["Diagnóstico personalizado", "Plano de acção escrito", "Mentoria contínua", "Presencial ou remoto"],
        },
      ],
    },
    portfolio: {
      overline: "Portfolio",
      title: "Antes",
      titleItalic: "· Depois",
      sub: "Uma selecção discreta de transformações reais — com autorização das famílias que abriram as suas portas.",
      cases: [
        { label: "Closet mestre · Cascais", tag: "Decluttering + Sistema" },
        { label: "Despensa · Lisboa", tag: "Organização integral" },
        { label: "Home office · Sintra", tag: "Consultoria + Layout" },
        { label: "Quarto infantil · Estoril", tag: "Sistema à medida" },
      ],
    },
    testemunhos: {
      overline: "Testemunhos",
      title: "O que dizem",
      titleItalic: "quando fecho a porta.",
      items: [
        {
          quote: "A Isa entrou em minha casa e devolveu-me tempo. Não é só arrumação — é uma forma de respirar de novo.",
          author: "Mariana C.",
          role: "Cliente · Cascais",
        },
        {
          quote: "Trabalho intuitivo, sem juízos, com um olhar de designer. O closet parece agora uma boutique privada.",
          author: "Sofia M.",
          role: "Cliente · Lisboa",
        },
        {
          quote: "Contratei a consultoria antes de uma mudança e poupei semanas de caos. Recomendo de olhos fechados.",
          author: "Ricardo P.",
          role: "Cliente · Porto",
        },
      ],
    },
    contacto: {
      overline: "Contacto",
      title: "Vamos criar",
      titleItalic: "ordem juntos.",
      sub: "Conte-me sobre o seu espaço. Respondo em menos de 24 horas úteis.",
      form: {
        name: "Nome completo",
        email: "Email",
        phone: "Telefone / WhatsApp",
        service: "Tipo de serviço",
        serviceOptions: ["Organização de Espaços", "Decluttering", "Consultoria", "Outro"],
        message: "Fale-me do seu espaço…",
        submit: "Enviar mensagem",
        sending: "A enviar…",
        success: "Mensagem enviada. Falo consigo em breve.",
        error: "Algo correu mal. Tente novamente ou escreva-me directamente.",
      },
      channels: {
        email: "ola@ordobyisa.pt",
        whatsapp: "+351 912 345 678",
        whatsappLabel: "WhatsApp",
      },
    },
    footer: {
      tag: "Home & Lifestyle Organization",
      rights: "Todos os direitos reservados",
      terms: "Termos & Condições",
      backTop: "Voltar ao topo",
    },
    terms: {
      title: "Termos & Condições",
      updated: "Última actualização · Janeiro 2026",
      back: "Voltar",
      sections: [
        {
          h: "1. Âmbito dos serviços",
          p: "A ORDO by Isa presta serviços de organização de espaços, decluttering e consultoria em Portugal continental e remotamente. Cada projecto é orçamentado individualmente após diagnóstico inicial.",
        },
        {
          h: "2. Marcação e pagamento",
          p: "A marcação de sessões implica sinal de 30% do valor acordado. O restante é liquidado no final do projecto por transferência bancária ou MB WAY.",
        },
        {
          h: "3. Cancelamentos",
          p: "Cancelamentos com mais de 72h de antecedência têm devolução integral do sinal. Cancelamentos com menos de 72h implicam a retenção de 50% do sinal.",
        },
        {
          h: "4. Confidencialidade",
          p: "Toda a informação partilhada durante o processo é estritamente confidencial. Imagens de portfolio só são partilhadas mediante autorização escrita do cliente.",
        },
        {
          h: "5. Doações e descarte",
          p: "O material identificado como excedente é encaminhado, sempre que possível, para instituições parceiras de doação. O cliente é informado e valida antes de qualquer descarte.",
        },
        {
          h: "6. Dados pessoais",
          p: "Os dados recolhidos no formulário de contacto são utilizados apenas para responder ao seu pedido, ao abrigo do RGPD. Pode solicitar remoção a qualquer momento.",
        },
      ],
    },
  },
  en: {
    nav: {
      inicio: "Home",
      sobre: "About",
      servicos: "Services",
      portfolio: "Portfolio",
      testemunhos: "Testimonials",
      contacto: "Contact",
      cta: "Book",
    },
    hero: {
      overline: "Personal Organizer · Algarve",
      line1: "Spaces",
      line2: "that breathe,",
      line3: "lives in",
      line4: "harmony.",
      sub: "Your home should be your sanctuary. If today it brings you stress instead of peace, you're in the right place.",
      cta: "Book a consultation",
      ctaAlt: "See services",
    },
    marquee: [
      "Declutter",
      "Organize",
      "Breathe",
      "Simplify",
      "Order",
      "Lightness",
      "Calm",
      "Design",
    ],
    sobre: {
      overline: "About",
      title: "I'm Isa —",
      titleItalic: "and order is my love language.",
      p1: "ORDO was born from the desire to give people back the quiet of the home they love. I'm a certified personal organizer with a background in interior design and over seven years transforming closets, kitchens and offices across the country.",
      p2: "My method is intuitive, discreet and deeply personal. I work with each family around their routine — not imposing systems, but revealing the ones already there, hidden underneath the excess.",
      stat1: { n: "120+", l: "Spaces transformed" },
      stat2: { n: "7 years", l: "Of experience" },
      stat3: { n: "98%", l: "Returning clients" },
    },
    servicos: {
      overline: "Services",
      title: "Three ways",
      titleItalic: "to start over.",
      items: [
        {
          num: "01",
          title: "Space Organization",
          desc: "Design and implementation of organization systems for every room — from closet to pantry, home office to children's rooms.",
          bullets: ["On-site analysis", "Categorization & purge", "Custom system", "Labels & finishing"],
        },
        {
          num: "02",
          title: "Decluttering",
          desc: "A guided process of conscious letting-go. Rediscover the essential, free up physical and mental space, and craft a home that reflects who you are today.",
          bullets: ["Category method", "Conscious donation", "Emotional support", "30-day follow-up"],
        },
        {
          num: "03",
          title: "Consulting",
          desc: "In-person sessions for those who want to reorganize their life and their home.",
          bullets: ["Personalized diagnosis", "Written action plan", "Ongoing mentoring", "In-person or remote"],
        },
      ],
    },
    portfolio: {
      overline: "Portfolio",
      title: "Before",
      titleItalic: "· After",
      sub: "A discreet selection of real transformations — shared with permission from the families who opened their doors.",
      cases: [
        { label: "Primary closet · Cascais", tag: "Decluttering + System" },
        { label: "Pantry · Lisbon", tag: "Full organization" },
        { label: "Home office · Sintra", tag: "Consulting + Layout" },
        { label: "Kid's room · Estoril", tag: "Custom system" },
      ],
    },
    testemunhos: {
      overline: "Testimonials",
      title: "What they say",
      titleItalic: "when I close the door.",
      items: [
        {
          quote: "Isa walked into my home and gave me time back. It's not just tidying — it's a way of breathing again.",
          author: "Mariana C.",
          role: "Client · Cascais",
        },
        {
          quote: "Intuitive work, no judgment, with a designer's eye. My closet now feels like a private boutique.",
          author: "Sofia M.",
          role: "Client · Lisbon",
        },
        {
          quote: "I hired the consulting before a move and saved weeks of chaos. I recommend her with my eyes closed.",
          author: "Ricardo P.",
          role: "Client · Porto",
        },
      ],
    },
    contacto: {
      overline: "Contact",
      title: "Let's create",
      titleItalic: "order together.",
      sub: "Tell me about your space. I reply within 24 working hours.",
      form: {
        name: "Full name",
        email: "Email",
        phone: "Phone / WhatsApp",
        service: "Service type",
        serviceOptions: ["Space Organization", "Decluttering", "Consulting", "Other"],
        message: "Tell me about your space…",
        submit: "Send message",
        sending: "Sending…",
        success: "Message sent. I'll be in touch soon.",
        error: "Something went wrong. Try again or write me directly.",
      },
      channels: {
        email: "ola@ordobyisa.pt",
        whatsapp: "+351 912 345 678",
        whatsappLabel: "WhatsApp",
      },
    },
    footer: {
      tag: "Home & Lifestyle Organization",
      rights: "All rights reserved",
      terms: "Terms & Conditions",
      backTop: "Back to top",
    },
    terms: {
      title: "Terms & Conditions",
      updated: "Last updated · January 2026",
      back: "Back",
      sections: [
        {
          h: "1. Scope of services",
          p: "ORDO by Isa provides space organization, decluttering and consulting services in mainland Portugal and remotely. Each project is quoted individually after an initial diagnosis.",
        },
        {
          h: "2. Booking and payment",
          p: "Booking sessions requires a 30% deposit of the agreed amount. The balance is settled at the end of the project by bank transfer or MB WAY.",
        },
        {
          h: "3. Cancellations",
          p: "Cancellations more than 72h in advance receive a full deposit refund. Cancellations under 72h retain 50% of the deposit.",
        },
        {
          h: "4. Confidentiality",
          p: "All information shared during the process is strictly confidential. Portfolio images are only shared with the client's written consent.",
        },
        {
          h: "5. Donations and disposal",
          p: "Material identified as surplus is directed, whenever possible, to partner donation institutions. The client is informed and validates before any disposal.",
        },
        {
          h: "6. Personal data",
          p: "Data collected in the contact form is used only to reply to your request, under GDPR. You may request removal at any time.",
        },
      ],
    },
  },
};
